import { TableRow, Typography } from '@mui/material';

import { ResponsibilityLetterOperatorsEnum } from '@services/CompanyService';

import { CardLine } from './styles';
import type { ChangeHistoryLineProps } from './types';

export function ChangeHistoryLine({
  changeHistoryLine,
}: Readonly<ChangeHistoryLineProps>) {
  const { createdAt, observation, operator } = changeHistoryLine;

  const isChangedByPortal =
    operator === ResponsibilityLetterOperatorsEnum.PORTAL;

  const operatorText = isChangedByPortal ? '<PORTAL>' : '<SIGO>';

  return (
    <TableRow>
      <CardLine>
        <Typography variant="text" whiteSpace="nowrap">
          <Typography variant="text" fontWeight={700}>
            Alterado em:
          </Typography>{' '}
          {createdAt} PELO SISTEMA {operatorText} - {observation}
        </Typography>
      </CardLine>
    </TableRow>
  );
}
